import { render, staticRenderFns } from "./SCMDashboard.vue?vue&type=template&id=38b0d29b&"
import script from "./SCMDashboard.vue?vue&type=script&lang=js&"
export * from "./SCMDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports